import { Button } from '@/components/ui/button'
import { Download, Loader2 } from 'lucide-react'
import { useExportSnapshotCsv } from '@/hooks/useAttendanceMetrics'
import { toast } from 'sonner'

interface SnapshotExportButtonProps {
  snapshotId: string
  variant?: 'default' | 'outline' | 'ghost'
  size?: 'default' | 'sm' | 'lg' | 'icon'
}

export function SnapshotExportButton({
  snapshotId,
  variant = 'outline',
  size = 'sm',
}: SnapshotExportButtonProps) {
  const exportMutation = useExportSnapshotCsv()

  const handleExport = async () => {
    try {
      await exportMutation.mutateAsync(snapshotId)
      toast.success('CSV exportado com sucesso!')
    } catch (error) {
      toast.error('Erro ao exportar CSV')
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleExport}
      disabled={exportMutation.isPending}
      className="gap-2"
    >
      {exportMutation.isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
      <span className="hidden sm:inline">Exportar CSV</span>
      <span className="sm:hidden">CSV</span>
    </Button>
  )
}
